<script>
import moment from 'moment/moment';
import BanService from '@/services/BanService';

export default {
  name: 'UpdateBan',
  props: {
    ban: {
      required: false,
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      localBan: { ...this.ban },
    };
  },
  computed: {
    minDate() {
      return this.getDateToday();
    },
  },
  methods: {
    async updateBan() {
      try {
        await BanService.updateBan(this.ban._id, this.localBan);
        this.$emit('close', true);
        this.$emit('refresh', true);
      } catch (e) {
        console.error('Error updating ban: ', e);
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getStartDate() {
      return moment(this.localBan.start_date).format('DD-MM-YYYY');
    },
    getDateToday() {
      return moment().format('YYYY-MM-DD');
    },
  },
}
</script>

<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(updateBan)">
      <section>
        <h3>User details</h3>
        {{ localBan.user_firstname }} {{ localBan.user_lastname }}
        <div class="mt-2">
          <label>Reason</label>
          <small class="d-block" style="margin-bottom: 5px">Please note this will be shown to the sender.</small>
          <validation-provider
            v-slot="validationContext"
            name="Reason"
            :rules="{ required: true, min: 5 }"
          >
            <b-form-textarea
              v-model="localBan.reason"
              rows="3" cy="ban-input-reason"
              max-rows="6"
              :state="getValidationState(validationContext)" class="mb-1" placeholder="Enter reason"
            />

            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>
        </div>
        <div>
          <label class="d-flex justify-content-between">End Date <span>Ban starts from ({{ getStartDate() }})</span></label>
          <validation-provider
            v-slot="validationContext"
            name="End-date"
            rules="required|future_date"
          >
            <b-form-datepicker v-model="localBan.end_date" class="mb-1" locale="en-uk"
                               placeholder="Enter end date"
                               :state="getValidationState(validationContext)"
                               cy="ban-input-date"
                               today-button
                               reset-button
                               close-button
                               :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                               :min="minDate"
            />

            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>
        </div>
      </section>
      <section class="d-inline-flex full-width mt-2">
        <div class="ui-spacer" />
        <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
        <b-button
          cy="ban-input-submit"
          type="submit"
          variant="primary"
        >
          Update Ban
        </b-button>
      </section>
    </b-form>
  </validation-observer>
</template>
